import * as React from "react";
import {
  GridColumnMenuFilter,
  GridColumnMenuFilterUIProps,
  GridColumnMenuProps,
} from "@progress/kendo-react-grid";
import { CustomFilterUiRadioButton } from "./CustomFilterUiRadioButton";

export function FoldedUnfoldedColumnMenu(props: GridColumnMenuProps) {
  const filterUi = (filterUiProps: GridColumnMenuFilterUIProps) => (
    <CustomFilterUiRadioButton
      {...filterUiProps}
      values={[
        {
          label: "F",
          value: "F",
        },
        {
          label: "U",
          value: "U",
        },
      ]}
    />
  );

  return (
    <div>
      <GridColumnMenuFilter {...props} expanded filterUI={filterUi} />
    </div>
  );
}
